import type { ReactNode, RefObject } from 'react';
import { SecondFactorSheet } from '../screens/account/SecondFactorSheet';
import { EmailPreferencesSheet } from '../screens/account/EmailPreferencesSheet';

/** Which of the profile's sheets is open. */
export type ProfileSheet = 'second-factor' | 'mail' | null;

/** The profile's two sheets; closing one hands the keyboard back to the profile's button. */
export function ProfileSheets({
  tenantId,
  back,
  shown,
  onClose,
}: {
  tenantId: string;
  back: RefObject<HTMLButtonElement | null>;
  shown: ProfileSheet;
  onClose: () => void;
}): ReactNode {
  if (shown === 'second-factor')
    return <SecondFactorSheet returnFocusTo={back} onClose={onClose} />;
  if (shown === 'mail')
    return <EmailPreferencesSheet tenantId={tenantId} returnFocusTo={back} onClose={onClose} />;
  return null;
}
